var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated revealUp"},[_c('div',{staticClass:"white-wrapper"},[_c('div',{staticClass:"section-title mb-4"},[_vm._v(_vm._s(_vm.$t("cogsReport")))]),_vm._v(" "),_c('div',{staticClass:"mt-3 mb-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-xl-3 align-self-center mb-4"},[_c('div',{staticClass:"input-material"},[_c('div',{staticClass:"add-datepicker"},[(_vm.getCOGSReportFromDate)?_c('button',{staticClass:"btn-clearDate",on:{"click":function($event){return _vm.onCOGSDropDownHandler({ event: null, name: 'fromDate' })}}},[_vm._v("\n                ✖\n              ")]):_vm._e(),_vm._v(" "),_c('Datepicker',{attrs:{"monday-first":true,"value":_vm.getCOGSReportFromDate,"typeable":""},on:{"selected":function($event){return _vm.onCOGSDropDownHandler({ event: $event, name: 'fromDate' })}}}),_vm._v(" "),_c('label',{class:_vm.getCOGSReportFromDate ? 'active' : ''},[_vm._v(_vm._s(_vm.$t("startdate")))])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-xl-3 align-self-center mb-4"},[_c('div',{staticClass:"input-material"},[_c('div',{staticClass:"add-datepicker"},[(_vm.getCOGSReportEndDate)?_c('button',{staticClass:"btn-clearDate",on:{"click":function($event){return _vm.onCOGSDropDownHandler({ event: null, name: 'endDate' })}}},[_vm._v("\n                ✖\n              ")]):_vm._e(),_vm._v(" "),_c('Datepicker',{attrs:{"monday-first":true,"value":_vm.getCOGSReportEndDate,"typeable":""},on:{"selected":function($event){return _vm.onCOGSDropDownHandler({ event: $event, name: 'endDate' })}}}),_vm._v(" "),_c('label',{class:_vm.getCOGSReportEndDate ? 'active' : ''},[_vm._v(_vm._s(_vm.$t("enddate")))])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-xl-3 align-self-center mb-4"},[_c('div',{staticClass:"dropdown-curve-container mr-2"},[_c('label',{class:_vm.getCOGSSelectedCinema ? 'shift-up' : ''},[_vm._v(_vm._s(_vm.$t("select"))+" "+_vm._s(_vm.$tc("cinema", 1)))]),_vm._v(" "),_c('b-dropdown',{staticClass:"w-100",attrs:{"text":_vm.getCOGSSelectedCinema,"variant":"dropdown-curve","disabled":_vm.isRoleID}},[_c('div',{staticClass:"px-2 pb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchCinema),expression:"searchCinema"}],staticClass:"form-control form-control-sm",attrs:{"required":"","autofocus":"","type":"search","placeholder":_vm.$tc('searchCinema')},domProps:{"value":(_vm.searchCinema)},on:{"keyup":function($event){return _vm.onSearchCinema()},"keydown":function($event){return _vm.onSearchCinema()},"search":function($event){return _vm.onSearchCinema()},"input":function($event){if($event.target.composing){ return; }_vm.searchCinema=$event.target.value}}})]),_vm._v(" "),_vm._l((_vm.Cinemas),function(dropdownItem,dropdownIndex){return _c('b-dropdown-item',{key:dropdownIndex,on:{"click":function($event){_vm.onCOGSDropDownHandler({
                    event: $event,
                    name: 'isCinema',
                    selectedItem: dropdownItem,
                    index: dropdownIndex
                  });
                  _vm.searchCinema = '';
                  _vm.onSearchCinema();
                  _vm.onSelectCinema(dropdownItem);}}},[_vm._v(_vm._s(dropdownItem.cine_name))])})],2)],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-xl-3 align-self-center mb-4"},[_c('div',{staticClass:"dropdown-curve-container mr-2"},[_c('label',{class:_vm.getCOGSSelectedRawMaterialCategory ? 'shift-up' : ''},[_vm._v(_vm._s(_vm.$t("select"))+" "+_vm._s(_vm.$tc("category", 1)))]),_vm._v(" "),_c('b-dropdown',{staticClass:"w-100",attrs:{"text":_vm.getCOGSSelectedRawMaterialCategory,"variant":"dropdown-curve"}},[_c('div',{staticClass:"px-2 pb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRawMaterial),expression:"searchRawMaterial"}],staticClass:"form-control form-control-sm",attrs:{"required":"","autofocus":"","type":"search","placeholder":_vm.$tc(_vm.searchRawMaterial)},domProps:{"value":(_vm.searchRawMaterial)},on:{"keyup":function($event){return _vm.onSearchRawMaterial()},"keydown":function($event){return _vm.onSearchRawMaterial()},"search":function($event){return _vm.onSearchRawMaterial()},"input":function($event){if($event.target.composing){ return; }_vm.searchRawMaterial=$event.target.value}}})]),_vm._v(" "),_vm._l((_vm.rawMaterialCategories),function(dropdownItem,dropdownIndex){return _c('b-dropdown-item',{key:dropdownIndex,on:{"click":function($event){_vm.onCOGSDropDownHandler({
                    event: $event,
                    name: 'isRawMaterialCategory',
                    selectedItem: dropdownItem,
                    index: dropdownIndex
                  });
                  _vm.searchRawMaterial = '';
                  _vm.onSearchRawMaterial();}}},[_vm._v(_vm._s(dropdownItem.rmc_category))])})],2)],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-xl-3 align-self-center mb-4"},[_c('button',{staticClass:"btn-blue-lg w-100",on:{"click":_vm.onFetchCOGSReports}},[_vm._v("\n            "+_vm._s(_vm.$tc("getReport"))+"\n          ")])]),_vm._v(" "),(_vm.getCOGSReportData.length > 0)?_c('div',{staticClass:"col-lg-8 col-xl-9 align-self-center mb-4 d-flex justify-content-end align-items-center"},[_c('div',[_vm._v(_vm._s(_vm.$t("download"))+" as:")]),_vm._v(" "),(_vm.getCOGSReportsPDFFileName)?_c('a',{attrs:{"href":_vm.BASE_URL + _vm.getCOGSReportsPDFFileName,"target":"_blank","download":"","title":"Download as PDF"}},[_c('img',{attrs:{"src":require("@/assets/img/icons/pdf-icon.svg"),"height":"25","width":"25"}})]):_vm._e(),_vm._v(" "),_c('a',{attrs:{"target":"_blank","title":"Download as Excel"},on:{"click":function($event){return _vm.excelDownload()}}},[_c('img',{staticClass:"mx-2",attrs:{"src":require("@/assets/img/icons/excel.svg"),"height":"25","width":"25"}})])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"swc-report",staticStyle:{"overflow-x":"scroll"}},[_c('table',{staticClass:"swc-report-table",staticStyle:{"width":"auto"},attrs:{"border":"1"}},[_c('thead',{staticClass:"bg-lightgrey",staticStyle:{"white-space":"nowrap"}},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$tc("rawmaterials")))]),_vm._v(" "),_c('th',[_vm._v("UOM")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("purchase"))+" "+_vm._s(_vm.$t("rate")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("openingStock")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("purchase")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("purchase"))+" "+_vm._s(_vm.$t("return")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("tranferInFromUnit")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("transferOutUnit")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("standard"))+" "+_vm._s(_vm.$t("consumption")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("system"))+" "+_vm._s(_vm.$t("stock")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("wastage")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("variance")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s("Total Wastage/Variance"))])])]),_vm._v(" "),(_vm.getCOGSReportData && _vm.getCOGSReportData.length == 0)?_c('tbody',[_c('tr',{attrs:{"rowspan":"13"}},[_c('td',{attrs:{"colspan":"13"}},[_c('NoRecords')],1)])]):_vm._l((_vm.getCOGSReportData),function(RawMaterialCategory,RawMaterialCategoryIndex){return _c('tbody',{key:RawMaterialCategoryIndex,staticClass:"sph-report"},[_c('tr',[_c('td',{staticClass:"font-weight-bold text-left",staticStyle:{"border-right-color":"transparent"},attrs:{"colspan":"2"}},[_vm._v("\n              "+_vm._s(RawMaterialCategory.RawMaterials[0].rmc_category)+"\n            ")]),_vm._v(" "),_c('td',{staticStyle:{"border-right-color":"transparent"}}),_vm._v(" "),_c('td',{staticStyle:{"border-right-color":"transparent"}}),_vm._v(" "),_c('td',{staticStyle:{"border-right-color":"transparent"}}),_vm._v(" "),_c('td',{staticStyle:{"border-right-color":"transparent"}}),_vm._v(" "),_c('td',{staticStyle:{"border-right-color":"transparent"}}),_vm._v(" "),_c('td',{staticStyle:{"border-right-color":"transparent"}}),_vm._v(" "),_c('td',{staticStyle:{"border-right-color":"transparent"}}),_vm._v(" "),_c('td',{staticStyle:{"border-right-color":"transparent"}}),_vm._v(" "),_c('td',{staticStyle:{"border-right-color":"transparent"}}),_vm._v(" "),_c('td',{staticStyle:{"border-right-color":"transparent"}}),_vm._v(" "),_c('td',{staticStyle:{"border-right-color":"transparent"}})]),_vm._v(" "),_vm._l((RawMaterialCategory.RawMaterials),function(singleRawItem,singleRawItemKey){return _c('tr',{key:singleRawItemKey,staticClass:"text-right"},[_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(singleRawItem.rm_name))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(singleRawItem.uom_short_form))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("RoundOff")(singleRawItem.purchase_rate)))]),_vm._v(" "),_c('td',[_c('div',[_vm._v(_vm._s(_vm.currFormat(singleRawItem.opening_stock)))]),_vm._v(" "),_c('div',[_vm._v("\n                "+_vm._s(_vm.currFormat(
                    singleRawItem.opening_stock * singleRawItem.purchase_rate
                  ))+"\n              ")])]),_vm._v(" "),_c('td',[_c('div',[_vm._v(_vm._s(singleRawItem.purchase))]),_vm._v(" "),_c('div',[_vm._v("\n                "+_vm._s(_vm.currFormat(
                    singleRawItem.purchase * singleRawItem.purchase_rate
                  ))+"\n              ")])]),_vm._v(" "),_c('td',[_c('div',[_vm._v(_vm._s(_vm.currFormat(singleRawItem.fgr_quantity) || 0.0))]),_vm._v(" "),_c('div',[_vm._v("\n                "+_vm._s(_vm.currFormat(
                    (singleRawItem.fgr_quantity || 0) *
                      singleRawItem.purchase_rate
                  ) || 0.0)+"\n              ")])]),_vm._v(" "),_c('td',[_c('div',[_vm._v(_vm._s(_vm.currFormat(singleRawItem.transfer_in) || 0.0))]),_vm._v(" "),_c('div',[_vm._v("\n                "+_vm._s(_vm.currFormat(
                    (singleRawItem.transfer_in || 0) *
                      singleRawItem.purchase_rate
                  ))+"\n              ")])]),_vm._v(" "),_c('td',[_c('div',[_vm._v(_vm._s(_vm.currFormat(singleRawItem.transfer_out) || 0.0))]),_vm._v(" "),_c('div',[_vm._v("\n                "+_vm._s(_vm.currFormat(
                    (singleRawItem.transfer_out || 0) *
                      singleRawItem.purchase_rate
                  ))+"\n              ")])]),_vm._v(" "),_c('td',[_c('div',[_vm._v(_vm._s(_vm.currFormat(singleRawItem.standard_consumption)))]),_vm._v(" "),_c('div',[_vm._v("\n                "+_vm._s(_vm.currFormat(
                    singleRawItem.standard_consumption *
                      singleRawItem.purchase_rate
                  ))+"\n              ")])]),_vm._v(" "),_c('td',[_c('div',[_vm._v(_vm._s(_vm.currFormat(singleRawItem.system_stock)))]),_vm._v(" "),_c('div',[_vm._v("\n                "+_vm._s(_vm.currFormat(
                    singleRawItem.system_stock * singleRawItem.purchase_rate
                  ))+"\n              ")])]),_vm._v(" "),_c('td',[_c('div',[_vm._v(_vm._s(_vm.currFormat(singleRawItem.wastage) || 0))]),_vm._v(" "),_c('div',[_vm._v("\n                "+_vm._s(_vm.currFormat(
                    singleRawItem.wastage * singleRawItem.purchase_rate
                  ))+"\n              ")])]),_vm._v(" "),_c('td',[_c('div',[_vm._v(_vm._s(_vm.currFormat(singleRawItem.ps_variance) || 0))]),_vm._v(" "),_c('div',[_vm._v("\n                "+_vm._s(_vm.currFormat(
                    singleRawItem.ps_variance * singleRawItem.purchase_rate
                  ))+"\n              ")])]),_vm._v(" "),_c('td',[_c('div',[_vm._v("\n                "+_vm._s(_vm.currFormat(
                    singleRawItem.wastage +
                      _vm.getOnlyPositiveNumber(singleRawItem.ps_variance)
                  ))+"\n              ")]),_vm._v(" "),_c('div',[_vm._v("\n                "+_vm._s(_vm.currFormat(
                    (singleRawItem.wastage +
                      _vm.getOnlyPositiveNumber(singleRawItem.ps_variance)) *
                      singleRawItem.purchase_rate
                  ))+"\n              ")])])])}),_vm._v(" "),_c('tr',{staticClass:"bg-lightgrey",staticStyle:{"text-align":"right"}},[_c('th',{staticStyle:{"vertical-align":"center","white-space":"nowrap","text-align":"left"},attrs:{"rowspan":"2"}},[_vm._v("\n              "+_vm._s(RawMaterialCategory.RawMaterials[0].rmc_category)+"\n              "),_c('span',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm.$t("total")))])]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"font-weight-bold text-left"},[_vm._v("Qty:")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  RawMaterialCategory.RawMaterials.reduce(
                    function (acc, ref) {
                                var opening_stock = ref.opening_stock;

                                return acc + opening_stock;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  RawMaterialCategory.RawMaterials.reduce(
                    function (acc, ref) {
                                var purchase = ref.purchase;

                                return acc + purchase;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  RawMaterialCategory.RawMaterials.reduce(
                    function (acc, ref) {
                                var fgr_quantity = ref.fgr_quantity;

                                return acc + fgr_quantity;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  RawMaterialCategory.RawMaterials.reduce(
                    function (acc, ref) {
                                var transfer_in = ref.transfer_in;

                                return acc + transfer_in;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  RawMaterialCategory.RawMaterials.reduce(
                    function (acc, ref) {
                                var transfer_out = ref.transfer_out;

                                return acc + transfer_out;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  RawMaterialCategory.RawMaterials.reduce(
                    function (acc, ref) {
                                  var standard_consumption = ref.standard_consumption;

                                  return acc + standard_consumption;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  RawMaterialCategory.RawMaterials.reduce(
                    function (acc, ref) {
                                var system_stock = ref.system_stock;

                                return acc + system_stock;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  RawMaterialCategory.RawMaterials.reduce(
                    function (acc, ref) {
                                var wastage = ref.wastage;

                                return acc + wastage;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  RawMaterialCategory.RawMaterials.reduce(
                    function (acc, ref) {
                                var ps_variance = ref.ps_variance;

                                return acc + ps_variance;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  RawMaterialCategory.RawMaterials.reduce(
                    function (acc, ref) {
                                  var wastage = ref.wastage;
                                  var ps_variance = ref.ps_variance;

                                  return acc + (wastage + _vm.getOnlyPositiveNumber(ps_variance));
                  },
                    0
                  )
                ))+"\n            ")])]),_vm._v(" "),_c('tr',{staticClass:"bg-lightgrey",staticStyle:{"text-align":"right"}},[_c('th',{}),_vm._v(" "),_c('th',{staticClass:"font-weight-bold text-left"},[_vm._v("Value:")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  RawMaterialCategory.RawMaterials.reduce(
                    function (acc, ref) {
                                  var opening_stock = ref.opening_stock;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc + opening_stock * purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  RawMaterialCategory.RawMaterials.reduce(
                    function (acc, ref) {
                                  var purchase = ref.purchase;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc + purchase * purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  RawMaterialCategory.RawMaterials.reduce(
                    function (acc, ref) {
                                  var fgr_quantity = ref.fgr_quantity;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc + fgr_quantity * purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  RawMaterialCategory.RawMaterials.reduce(
                    function (acc, ref) {
                                  var transfer_in = ref.transfer_in;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc + transfer_in * purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  RawMaterialCategory.RawMaterials.reduce(
                    function (acc, ref) {
                                  var transfer_out = ref.transfer_out;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc + transfer_out * purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  RawMaterialCategory.RawMaterials.reduce(
                    function (acc, ref) {
                                  var standard_consumption = ref.standard_consumption;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc + standard_consumption * purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  RawMaterialCategory.RawMaterials.reduce(
                    function (acc, ref) {
                                  var system_stock = ref.system_stock;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc + system_stock * purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  RawMaterialCategory.RawMaterials.reduce(
                    function (acc, ref) {
                                  var wastage = ref.wastage;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc + wastage * purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  RawMaterialCategory.RawMaterials.reduce(
                    function (acc, ref) {
                                  var ps_variance = ref.ps_variance;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc + ps_variance * purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  RawMaterialCategory.RawMaterials.reduce(
                    function (acc, ref) {
                                  var wastage = ref.wastage;
                                  var ps_variance = ref.ps_variance;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc +
                      (wastage + _vm.getOnlyPositiveNumber(ps_variance)) *
                        purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")])]),_vm._v(" "),(
              RawMaterialCategoryIndex == _vm.getCOGSReportData.length - 1 &&
                false
            )?_c('tr',{staticStyle:{"text-align":"right"}},[_c('th',{staticStyle:{"vertical-align":"bottom","white-space":"nowrap"}}),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"font-weight-bold text-left"},[_vm._v("Qty:")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getNonReccoRecords.reduce(
                    function (acc, ref) {
                                var opening_stock = ref.opening_stock;

                                return acc + opening_stock;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getNonReccoRecords.reduce(
                    function (acc, ref) {
                                var purchase = ref.purchase;

                                return acc + purchase;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getNonReccoRecords.reduce(
                    function (acc, ref) {
                                var fgr_quantity = ref.fgr_quantity;

                                return acc + fgr_quantity;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getNonReccoRecords.reduce(
                    function (acc, ref) {
                                var transfer_in = ref.transfer_in;

                                return acc + _vm.fgr_quantity;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getNonReccoRecords.reduce(
                    function (acc, ref) {
                                var transfer_out = ref.transfer_out;

                                return acc + _vm.fgr_quantity;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getNonReccoRecords.reduce(
                    function (acc, ref) {
                                  var standard_consumption = ref.standard_consumption;

                                  return acc + standard_consumption;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getNonReccoRecords.reduce(
                    function (acc, ref) {
                                var system_stock = ref.system_stock;

                                return acc + system_stock;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getNonReccoRecords.reduce(
                    function (acc, ref) {
                                var wastage = ref.wastage;

                                return acc + wastage;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getNonReccoRecords.reduce(
                    function (acc, ref) {
                                var ps_variance = ref.ps_variance;

                                return acc + ps_variance;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getNonReccoRecords.reduce(
                    function (acc, ref) {
                                  var wastage = ref.wastage;
                                  var ps_variance = ref.ps_variance;

                                  return acc + (wastage + _vm.getOnlyPositiveNumber(ps_variance));
                  },
                    0
                  )
                ))+"\n            ")])]):_vm._e(),_vm._v(" "),(
              RawMaterialCategoryIndex == _vm.getCOGSReportData.length - 1 &&
                false
            )?_c('tr',{staticStyle:{"text-align":"right"}},[_c('th',{staticClass:"text-right",staticStyle:{"vertical-align":"bottom","white-space":"nowrap"},attrs:{"colspan":"2"}},[_vm._v("\n              Non Reconcile Raw Material\n            ")]),_vm._v(" "),_c('th',{staticClass:"font-weight-bold text-left"},[_vm._v("Value :")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getNonReccoRecords.reduce(
                    function (acc, ref) {
                                  var opening_stock = ref.opening_stock;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc + opening_stock * purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getNonReccoRecords.reduce(
                    function (acc, ref) {
                                  var purchase = ref.purchase;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc + purchase * purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getNonReccoRecords.reduce(
                    function (acc, ref) {
                                  var fgr_quantity = ref.fgr_quantity;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc + fgr_quantity;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getNonReccoRecords.reduce(
                    function (acc, ref) {
                                  var transfer_in = ref.transfer_in;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc + transfer_in * purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getNonReccoRecords.reduce(
                    function (acc, ref) {
                                  var transfer_out = ref.transfer_out;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc + transfer_out * purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getNonReccoRecords.reduce(
                    function (acc, ref) {
                                  var standard_consumption = ref.standard_consumption;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc + standard_consumption * purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getNonReccoRecords.reduce(
                    function (acc, ref) {
                                  var system_stock = ref.system_stock;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc + system_stock * purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getNonReccoRecords.reduce(
                    function (acc, ref) {
                                  var wastage = ref.wastage;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc + wastage * purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getNonReccoRecords.reduce(
                    function (acc, ref) {
                                  var ps_variance = ref.ps_variance;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc + ps_variance * purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getNonReccoRecords.reduce(
                    function (acc, ref) {
                                  var wastage = ref.wastage;
                                  var ps_variance = ref.ps_variance;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc +
                      (wastage + _vm.getOnlyPositiveNumber(ps_variance)) *
                        purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")])]):_vm._e(),_vm._v(" "),(RawMaterialCategoryIndex == _vm.getCOGSReportData.length - 1)?_c('tr',{staticClass:"bg-lightgrey",staticStyle:{"text-align":"right"}},[_c('th',{staticClass:"text-right",staticStyle:{"vertical-align":"bottom","white-space":"nowrap"}},[_vm._v("\n              Grand Qty:\n            ")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"font-weight-bold text-left"},[_vm._v("Qty :")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getAllCOGSReportData.reduce(
                    function (acc, ref) {
                                var opening_stock = ref.opening_stock;

                                return acc + opening_stock;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getAllCOGSReportData.reduce(
                    function (acc, ref) {
                                var purchase = ref.purchase;

                                return acc + purchase;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getAllCOGSReportData.reduce(
                    function (acc, ref) {
                                var fgr_quantity = ref.fgr_quantity;

                                return acc + fgr_quantity;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getAllCOGSReportData.reduce(
                    function (acc, ref) {
                                var transfer_in = ref.transfer_in;

                                return acc + transfer_in;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getAllCOGSReportData.reduce(
                    function (acc, ref) {
                                var transfer_out = ref.transfer_out;

                                return acc + transfer_out;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getAllCOGSReportData.reduce(
                    function (acc, ref) {
                                  var standard_consumption = ref.standard_consumption;

                                  return acc + standard_consumption;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getAllCOGSReportData.reduce(
                    function (acc, ref) {
                                var system_stock = ref.system_stock;

                                return acc + system_stock;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getAllCOGSReportData.reduce(
                    function (acc, ref) {
                                var wastage = ref.wastage;

                                return acc + wastage;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getAllCOGSReportData.reduce(
                    function (acc, ref) {
                                var ps_variance = ref.ps_variance;

                                return acc + ps_variance;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getAllCOGSReportData.reduce(
                    function (acc, ref) {
                                  var wastage = ref.wastage;
                                  var ps_variance = ref.ps_variance;

                                  return acc + (wastage + _vm.getOnlyPositiveNumber(ps_variance));
                  },
                    0
                  )
                ))+"\n            ")])]):_vm._e(),_vm._v(" "),(RawMaterialCategoryIndex == _vm.getCOGSReportData.length - 1)?_c('tr',{staticClass:"bg-lightgrey",staticStyle:{"text-align":"right"}},[_c('th',{staticClass:"text-right",staticStyle:{"vertical-align":"bottom","white-space":"nowrap"}},[_vm._v("\n              Grand Total:\n            ")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"font-weight-bold text-left",staticStyle:{"white-space":"nowrap"}},[_vm._v("\n              Value :\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getAllCOGSReportData.reduce(
                    function (acc, ref) {
                                  var opening_stock = ref.opening_stock;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc + opening_stock * purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getAllCOGSReportData.reduce(
                    function (acc, ref) {
                                  var purchase = ref.purchase;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc + purchase * purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getAllCOGSReportData.reduce(
                    function (acc, ref) {
                                  var fgr_quantity = ref.fgr_quantity;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc + fgr_quantity * purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getAllCOGSReportData.reduce(
                    function (acc, ref) {
                                  var transfer_in = ref.transfer_in;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc + transfer_in * purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getAllCOGSReportData.reduce(
                    function (acc, ref) {
                                  var transfer_out = ref.transfer_out;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc + transfer_out * purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getAllCOGSReportData.reduce(
                    function (acc, ref) {
                                  var standard_consumption = ref.standard_consumption;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc + standard_consumption * purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getAllCOGSReportData.reduce(
                    function (acc, ref) {
                                  var system_stock = ref.system_stock;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc + system_stock * purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getAllCOGSReportData.reduce(
                    function (acc, ref) {
                                  var wastage = ref.wastage;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc + wastage * purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getAllCOGSReportData.reduce(
                    function (acc, ref) {
                                  var ps_variance = ref.ps_variance;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc +
                      _vm.getOnlyPositiveNumber(ps_variance) * purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")]),_vm._v(" "),_c('th',[_vm._v("\n              "+_vm._s(_vm.currFormat(
                  _vm.getAllCOGSReportData.reduce(
                    function (acc, ref) {
                                  var wastage = ref.wastage;
                                  var ps_variance = ref.ps_variance;
                                  var purchase_rate = ref.purchase_rate;

                                  return acc +
                      (wastage + _vm.getOnlyPositiveNumber(ps_variance)) *
                        purchase_rate;
                  },
                    0
                  )
                ))+"\n            ")])]):_vm._e()],2)})],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be3dba12","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/ReportsContainer/cogsReport.vue
// module id = null
// module chunks = 